<template>
  <!-- 专家角色 -->
  <yioks-content @back="handleBack">
    <template v-slot:nav_left>
      <div class="nav-btn-box" :title="`${youthShortName}`">机构提交信息（{{youthShortName}}）</div>
    </template>
    <template v-slot:nav_right>
      <template v-if="isInClubSystem">
        <template v-if="!audit">
          <div v-if="isAduit" class="yioks_btn yioks_audit" @click="handleAuditTarget">
            结果确认
          </div>
        </template>
      </template>
      <div
        v-if="orgAuditStageLogList.length"
        class="yioks_btn"
        @click="handleViewAuditList"
      >
        审核记录
      </div>
      <template v-if="isInClubSystem">
        <div class="yioks_btn" @click="handleDownloadAllFiles">下载全部文件</div>
      </template>
    </template>

    <template v-slot:content_right>
      <div class="base-content-wrapper">
        <div class="content-inner-wrapper">
          <!-- <div class="select_wrap">
            <div class="select_box left"></div>
            <div class="select_box right">
            </div>
          </div> -->

          <div class="list_wrap" v-if="!loading && !empty">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th youthName">评估指标</div>
                  <div
                    class="th youthShortName"
                    :class="{ big: !isInClubSystem }"
                  >
                    评估内容
                  </div>
                  <div class="th submit">分值分配</div>
<!--                  <template v-if="isInClubSystem">-->
<!--                    <div class="th audit">自评得分</div>-->

<!--                  </template>-->
                  <div class="th auditScore">评估得分</div>
                  <div class="th action">评估材料</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in expertBoundTargetSecondlyList"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td youthName double">

                          <template v-if="isInClubSystem">
                            <p class="suc" :title="`【${item.targetSecondlyName}】`">
                              【{{ item.targetSecondlyName }}】
                            </p>
                            <p :title="item.targetThirdlyName">
                              {{ item.targetThirdlyName }}
                            </p>
                          </template>
                          <template v-else>
                            <p class="suc" :title="`【${item.targetSecondlyName}】`">
                              【{{ item.targetSecondlyName }}】
                            </p>
                            <p :title="item.targetThirdlyName">
                              {{ item.targetThirdlyName }}
                            </p>
                          </template>
                        </div>
                        <div
                          class="td youthShortName" :class="{ big: !isInClubSystem }"
                        >
                          <p :title="item.targetSecondlyRemark">
                            {{ item.targetSecondlySuggest }}
                          </p>
                        </div>
                        <div class="td submit">
                          <p>0 ~ {{ item.targetSecondlyTotalScore }}</p>
                        </div>
<!--                        <template v-if="isInClubSystem">-->
<!--                          <div class="td audit">-->
<!--                            <p>{{ item.score || 0 }}</p>-->
<!--                          </div>-->

<!--                        </template>-->
                        <div class="td auditScore">
                          <p v-if="item.expertAuditScoreUuid !== undefined && item.targetSecondlyTotalScore === 0">{{ item.qualified ? '材料不合格' : '材料合格' }}</p>
                          <p v-else>{{ item.expertAuditScore | auditScoreFiler }}</p>
                        </div>
<!--                        <template v-if="isInClubSystem">-->
<!--                          <div class="td action">-->
<!--                            <p :data-autid="audit">-->
<!--                              <template v-if="item.submit">-->
<!--                                &lt;!&ndash; 已审核操作 &ndash;&gt;-->
<!--                                <template v-if="!audit">-->
<!--                                <span-->
<!--                                  class="item active"-->
<!--                                  v-if="item.expertAuditScoreUuid"-->
<!--                                  @click="handleUploadScore(item, false)"-->
<!--                                >编辑打分</span-->
<!--                                >-->
<!--                                  <span-->
<!--                                    class="item active"-->
<!--                                    v-else-->
<!--                                    @click="handleUploadScore(item, false)"-->
<!--                                  >审核打分</span-->
<!--                                  >-->
<!--                                </template>-->
<!--                                &lt;!&ndash; 未审核操作 &ndash;&gt;-->
<!--                                <template v-else>-->
<!--                                <span-->
<!--                                  class="item active"-->
<!--                                  @click="handleUploadScore(item, true)"-->
<!--                                >查看</span-->
<!--                                >-->
<!--                                </template>-->
<!--                              </template>-->
<!--                              <template v-else>-->
<!--                                <span class="item">暂无文件</span>-->
<!--                              </template>-->
<!--                            </p>-->
<!--                          </div>-->
<!--                        </template>-->
                        <template >
                          <div class="td action">
                            <template v-if="!isAduit">
<!--                              <template v-if="item.submit">-->
<!--                                <span-->
<!--                                  class="item active"-->
<!--                                  v-if="item.expertAuditScoreUuid"-->
<!--                                  @click="handleUploadScore(item, false)"-->
<!--                                >编辑打分</span-->
<!--                                >-->
<!--                                <span-->
<!--                                  class="item active"-->
<!--                                  v-else-->
<!--                                  @click="handleUploadScore(item, false)"-->
<!--                                >专家打分</span-->
<!--                                >-->
<!--                              </template>-->
<!--                              <template v-else>-->
<!--                                <span class="item">未提交</span>-->
<!--                              </template>-->
                              <span
                                class="item active"
                                v-if="item.expertAuditScoreUuid"
                                @click="handleUploadScore(item, false)"
                              >编辑打分</span
                              >
                              <span
                                class="item active"
                                v-else
                                @click="handleUploadScore(item, false)"
                              >专家打分</span
                              >
                              <span  v-if="!item.submit" class="item">(未提交)</span>

                            </template>
                            <!-- 未审核操作 -->
                            <template v-else>
                                <span
                                  class="item active"
                                  @click="handleUploadScore(item, true)"
                                >查看</span
                                >
                            </template>
                          </div>
                        </template>

                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>

            <template v-if="isInClubSystem">
              <div class="footer-tips">
                <!--              <span>评估进程：{{ tongji }}%</span>-->
<!--                <span style="margin-left: 40px">自评得分：{{ auditTotalScore }}</span>-->
                <!-- jixiaoScore.youthScore -->
                <span style="margin-left: 40px"
                >评估得分：{{ expertAuditScore }}</span
                >
              </div>
            </template>
          </div>

          <yioks-empty v-if="empty"></yioks-empty>
          <yioks-loading v-if="loading"></yioks-loading>

          <!-- 审核记录 -->
          <template v-if="isShowAuditList">
            <audit-history-list
              :isShow.sync="isShowAuditList"
              :auditList="orgAuditStageLogList"
            >
            </audit-history-list>
          </template>

          <!-- 审核弹窗 -->
          <template v-if="isShowAudit">
            <org-audit-msg
              :isShow.sync="isShowAudit"
              :stageUuid="stageUuid"
              :youthUuid="youthUuid"
              :groupUuid="groupUuid"
              :auditTotalScore="expertAuditScore"
              :isShowScore="true"
              :selectOptionsForDeny="selectOptionsForDeny"
              @callback="orgAuditCallback"
            >
            </org-audit-msg>
          </template>

          <!-- club 用文件下载，提交成绩 -->
          <template v-if="isShowUploadScore">
            <downlad-view-club
              :isShow.sync="isShowUploadScore"
              :configInfo="downloadViewInfoForClub"
              @callbackForClub="handleViewCallBackForClub"
            >
            </downlad-view-club>
          </template>
        </div>
      </div>
    </template>
  </yioks-content>
</template>

<script>
import { getExpertTargetAuditList, getAllFileForExpertDownload } from "@/api/export/index";
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { downloadByJs } from "@/utils/commen";
import mixinAppConfig from "@/mixin/mixinAppConfig";

export default {
  mixins: [mixinAppConfig],
  data() {
    return {
      loading: false,
      empty: false,
      jixiaoOrgToScore: {}, // 上级评分
      expertBoundTargetSecondlyList: [],
      downloastList: [], // 指标文件列表
      submitForm: {
        orgAppraise: "", // 上级评价
        orgScore: "", // 上级评分
        orgRating: "", // 上级评价等级
      },
      downloadRow: {},
      submitFormRules: {
        // orgAppraise: [requiredItem("评估结果概述")],
        orgScore: [requiredItem("评估得分"), numberRequired("评估得分")],
      },

      isShowDialogDetails: false,
      isReadOnly: false,

      isAduit: false,
      orgAuditStageLogList: [],
      isShowAuditList: false,

      isShowAudit: false,
      selectOptionsForDeny: [],

      isShowUploadScore: false,
      downloadViewInfoForClub: {},
    };
  },

  components: { // src\views\export\performance\components\ExpertAuditMsg.vue
    "audit-history-list": () => import("@/views/performance/components/AuditHistoryList"),
    "org-audit-msg": () => import("@/views/export/performance/components/ExpertAuditMsg"),
    "downlad-view": () =>
      import("@/views/performance/downloadStageLabelsAndFiles"),
    "downlad-view-club": () =>
      import("@/views/export/performance/components/ExpertAuditScore"),
  },

  computed: {
    groupUuid() {
      const { groupUuid } = this.$route.query;
      return groupUuid;
    },
    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid;
    },
    youthUuid() {
      const { youthUuid } = this.$route.query;
      return youthUuid;
    },
    youthName() {
      const { youthName } = this.$route.query;
      return youthName;
    },
    youthShortName() {
      const { youthShortName } = this.$route.query;
      return youthShortName;
    },
    audit() {
      const { audit } = this.$route.query;
      if (audit == "true") return true;
      if (audit == "false") return false;
      else return false;
    },

    // 自评得分
    auditTotalScore() {
      let auditTotalScore = 0;
      if (this.expertBoundTargetSecondlyList.length) {
        this.expertBoundTargetSecondlyList.forEach((item) => {
          const { score } = item;
          if (typeof score === "number") {
            auditTotalScore += score;
          }
        });
      }
      return auditTotalScore;
    },

    // 评估得分
    expertAuditScore() {
      let auditTotalScore = 0;
      if (this.expertBoundTargetSecondlyList.length) {
        this.expertBoundTargetSecondlyList.forEach((item) => {
          const { expertAuditScore } = item;
          if (typeof expertAuditScore === "number") {
            auditTotalScore += expertAuditScore;
          }
        });
      }
      return auditTotalScore;
    },

    tongji() {
      if(this.expertBoundTargetSecondlyList.length) {
        let all_submit = 0;
        const all_length = this.expertBoundTargetSecondlyList.length;
        this.expertBoundTargetSecondlyList.forEach(item => {
          // if(item.auditScoreUuid) {
          if(item.scoreUuid) {
            all_submit += 1;
          }
        })
        return ((all_submit/all_length) * 100).toFixed(0)
      } else {
        return 0
      }
    },
  },

  filters: {
    auditScoreFiler(val) {
      if (val !== undefined || val === "") {
        return val;
      } else {
        return "--";
      }
    },
  },

  created() {
    this.loadPageDetails();
  },

  methods: {
    handleBack() {
      this.$router.back();
    },

    // 加载页面列表信息
    loadPageDetails(flag = false) {
      const paramsData = {
        groupUuid: this.groupUuid,
        stageUuid: this.stageUuid,
        youthUuid: this.youthUuid,
        targetSecondlyName: "",
      };
      if(!flag) this.loading = true;
      getExpertTargetAuditList(paramsData)
        .then((res) => {
          this.loading = false;
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const { audit, orgAuditStageLogList, expertBoundTargetSecondlyList } = res;
          if (expertBoundTargetSecondlyList.length) {
            this.empty = false;
          } else {
            this.empty = true;
          }
          this.expertBoundTargetSecondlyList = expertBoundTargetSecondlyList;
          this.orgAuditStageLogList = orgAuditStageLogList;
          this.isAduit = audit;
          this.selectOptionsForDeny = expertBoundTargetSecondlyList.map((item) => {
            return {
              label: item.targetThirdlyName,
              value: item.uuid,
            };
          });
        })
        .catch((err) => {
          this.loading = false;
          this.empty = true;
          console.error("err", err);
        });
    },


    // 下载全部文件
    handleDownloadAllFiles() {
      const queryData = {
        youthUuid: this.youthUuid,
        stageUuid: this.stageUuid,
      };
      getAllFileForExpertDownload(queryData)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const { fileName, filePath } = res;
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
          downloadByJs(transferPath, fileName);
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 审核该组织
    handleAuditTarget() {
      this.isShowAudit = true;
    },
    // 查看审核记录
    handleViewAuditList() {
      this.isShowAuditList = true;
    },
    // 审核弹窗 callback function
    orgAuditCallback(status) {
      if (status) {
        this.$router.back();
      }
    },
    handleUploadScore(row, isDisabled) {
      const {
        targetSecondlyTotalScore,
        scoreUuid,
        expertAuditScore,
        expertAuditScoreUuid,
        targetSecondlyUuid,
        groupUuid,
        expertUuid,
        score,
        auditRemark,
        rectificationSuggestion,
      } = row;
      this.downloadViewInfoForClub = {
        targetSecondlyUuid: targetSecondlyUuid,
        stageUuid: this.stageUuid,
        youthUuid: this.youthUuid,
        groupUuid: groupUuid,
        expertUuid: expertUuid,
        orgAuditScore: expertAuditScore,
        targetSecondlyTotalScore: targetSecondlyTotalScore,
        score: score,
        // auditScoreUuid: auditScoreUuid,
        orgAuditScoreUuid: expertAuditScoreUuid,
        youthName: this.youthName,
        isDisabled: isDisabled || false,
        auditRemark: auditRemark,
        rectificationSuggestion: rectificationSuggestion,
      };
      this.isShowUploadScore = true;
    },
    // club弹窗信息回调
    handleViewCallBackForClub(flag) {
      if (flag) {
        this.loadPageDetails(true);
      }
      this.isShowUploadScore = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  padding-top 45px
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        min-height 45px
        height auto
        display flex
    .scrollArea
      height 480px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 49px
        height auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        white-space pre-line
        padding 3px 5px
        text-align center
        line-height 1.4em
        color $color_white
.seq
  width 6%
.youthName
  width 24%
.double
  display flex
  flex-direction column
  justify-content center
  align-items center
  p
    text-align center
    width 100%
    white-space pre-line
    // white-space nowrap
    // overflow hidden
    // text-overflow ellipsis
  .suc
    color $green_color !important
.youthShortName
  width 30%
  &.big
    width 50%
  p
    width 100%
    text-align left !important
.submit
  width 10%
.audit
  width 10%
.auditScore
  width 14%
.action
  width 16%
  .item
    cursor pointer
    user-select none
    &.active
      color $green_color
    &.warn
      color $orange_color
  .split
    margin 0 5px
.download-list-wrapper
  padding 0px 20px 20px !important
  .download-item
    font-size 16px
    line-height 1.2em
    margin-bottom 10px
    &:last-child
      margin-bottom 0px
    a
      margin-left 8px
      color $green_color !important
.footer-tips
  height 40px
  padding 0 40px
  display flex
  justify-content flex-end
  align-items center
  font-size 18px
  color red
.action-box
  margin-top 15px
  display flex
  align-items center
  justify-content center
</style>

<style lang="stylus" >
.y-input
  width 180px
  margin-right 20px
  input
    border-radius 0px !important
</style>
<style lang="stylus" scoped>
.yioks-form-item
  width 340px
.footer-btn-group
  width 60%
  margin 0 auto
  display flex
  justify-content space-around

.listBox
  .yioks_audit
    background #F88594
</style>
